import React, { useState } from 'react'
import { Pagination } from 'react-bootstrap'
import './styles.css'
import { isNewWindow } from '../../../utils/helpers'

const LEFT_PAGE = 'LEFT'
const RIGHT_PAGE = 'RIGHT'

const range = (from, to, step = 1) => {
  let i = from
  const range = []

  while (i <= to) {
    range.push(i)
    i += step
  }

  return range
}

export const CustomPagination = ({
  activePage,
  onPageChanged,
  totalRecords = 0,
  pageLimit = 10,
  pageNeighbours = 3,
}) => {
  const [currentPage, setCurrentPage] = useState(activePage || 1)

  const totalPages = Math.ceil(totalRecords / pageLimit)
  const gotoPage = (page, event) => {
    const currentPage = Math.max(0, Math.min(page, totalPages))
    if (!isNewWindow(event)) {
      setCurrentPage(currentPage)
    }

    onPageChanged(currentPage, isNewWindow(event))
  }

  const fetchPageNumbers = () => {
    const totalNumbers = pageNeighbours * 2 + 3
    const totalBlocks = totalNumbers + 2

    if (totalPages > totalBlocks) {
      let pages = []

      const leftBound = currentPage - pageNeighbours
      const rightBound = currentPage + pageNeighbours
      const beforeLastPage = totalPages - 1

      const startPage = leftBound > 2 ? leftBound : 2
      const endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage

      pages = range(startPage, endPage)

      const pagesCount = pages.length
      const singleSpillOffset = totalNumbers - pagesCount - 1

      const leftSpill = startPage > 2
      const rightSpill = endPage < beforeLastPage

      const leftSpillPage = LEFT_PAGE
      const rightSpillPage = RIGHT_PAGE

      if (leftSpill && !rightSpill) {
        const extraPages = range(startPage - singleSpillOffset, startPage - 1)
        pages = [leftSpillPage, ...extraPages, ...pages]
      } else if (!leftSpill && rightSpill) {
        const extraPages = range(endPage + 1, endPage + singleSpillOffset)
        pages = [...pages, ...extraPages, rightSpillPage]
      } else if (leftSpill && rightSpill) {
        pages = [leftSpillPage, ...pages, rightSpillPage]
      }

      return [1, ...pages, totalPages]
    }

    return range(1, totalPages)
  }
  const handleMoveLeft = (evt) => {
    evt.preventDefault()
    if (currentPage > 1) {
      gotoPage(currentPage - 1, evt)
    }
  }

  const handleMoveRight = (evt) => {
    evt.preventDefault()
    if (currentPage < totalPages) {
      gotoPage(currentPage + 1, evt)
    }
  }
  const handleClick = (page, evt) => {
    evt.preventDefault()
    gotoPage(page, evt)
  }
  const pages = fetchPageNumbers()
  return (
    <Pagination className={'custom-pagination'}>
      <Pagination.Prev className={currentPage === 1 ? 'disabled' : ''} onClick={handleMoveLeft} />
      {pages.map((page, index) => {
        if (page === LEFT_PAGE)
          return (
            <Pagination.Item className={'disabled'} key={index}>
              ...
            </Pagination.Item>
          )
        if (page === RIGHT_PAGE)
          return (
            <Pagination.Item className={'disabled'} key={index}>
              ...
            </Pagination.Item>
          )

        return (
          <Pagination.Item key={index} active={currentPage === page} onClick={(e) => handleClick(page, e)}>
            {page}
          </Pagination.Item>
        )
      })}
      <Pagination.Next className={currentPage === totalPages ? 'disabled' : ''} onClick={handleMoveRight} />
    </Pagination>
  )
}
